import { createContext } from 'react';

interface IConversationContext {
  conversationId: string;
}

const initialState: IConversationContext = {
  conversationId: '',
};

export default createContext<IConversationContext>(initialState);
